<!-- src/app/components/timezone-select/timezone-select.component.html -->
<ion-header>
  <ion-toolbar>
    <ion-title>Zeitzone wählen</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Schließen</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar
    placeholder="Suchen (z. B. Europe/Vienna)…"
    (ionInput)="onSearchChange($event)"
  ></ion-searchbar>

  <ion-list>
    <ion-item button *ngFor="let tz of filtered" (click)="pick(tz)">
      {{ tz }}
    </ion-item>
  </ion-list>
</ion-content>
